import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'
import Immutable from 'immutable'
import React from 'react'
import { useSelector } from 'react-redux'
import { CuratedBoxOpenMenuTile } from './Components/CuratedBoxOpenMenuTile/CuratedBoxOpenMenuTile'
import { CuratedBoxRecipe } from './Components/CuratedBoxRecipeTile/CuratedBoxRecipeTile'
import { CuratedBoxesRecipesType, getCuratedBoxesRecipes } from './utils/getCuratedBoxesRecipes'
import { CuratedBoxLoader } from './Components/CuratedBoxLoader/CuratedBoxLoader'

type HandleRecipe = (
  curatedBoxRecipes: string[],
  curatedBoxCollectionId: string,
  curatedBoxName: string,
) => void

type CuratedBoxLayoutProps = {
  curatedBoxesMethods: {
    getRecipes: () => Immutable.Map<string, string>
    getNumPortions: () => 1 | 2 | 3 | 4 | 5
    getRecipeStock: {
      isRecipeOutOfStock: (id: string) => boolean
    }
    getCuratedBoxes: () => CuratedBoxesRecipesType
  }
  handleOnClickForCuratedBox: HandleRecipe
  handleEditCuratedBox: HandleRecipe
  handleShowRecipeDetails: (recipeId: string, categoryIds: string) => void
  handleOnClickOpenMenu: () => void
}

export const CuratedBoxLayout = ({
  curatedBoxesMethods,
  handleOnClickForCuratedBox,
  handleShowRecipeDetails,
  handleOnClickOpenMenu,
  handleEditCuratedBox,
}: CuratedBoxLayoutProps) => {
  const { isRecipeOutOfStock } = curatedBoxesMethods.getRecipeStock
  const allRecipes = useSelector(curatedBoxesMethods.getRecipes)
  const numPortions = useSelector(curatedBoxesMethods.getNumPortions)

  const curatedBoxesRecipes = useSelector(curatedBoxesMethods.getCuratedBoxes)
  const recipesToJS = allRecipes.toJS()
  const curatedBoxesData = getCuratedBoxesRecipes(
    recipesToJS,
    curatedBoxesRecipes,
    isRecipeOutOfStock,
    numPortions,
  )

  return (
    <Box>
      <Box>
        {curatedBoxesData.length ? (
          <Box
            display={Display.Flex}
            flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
            wrap
          >
            {curatedBoxesData.map((curatedBoxData) => (
              <Box
                paddingH={2}
                paddingV={2}
                key={curatedBoxData.id}
                width={['100%', null, '50%', '33%', '33%']}
              >
                <CuratedBoxRecipe
                  curatedBoxData={curatedBoxData}
                  handleRecipePreview={handleShowRecipeDetails}
                  handleOnClick={handleOnClickForCuratedBox}
                  handleEditCuratedBox={handleEditCuratedBox}
                  numPortions={numPortions}
                />
              </Box>
            ))}
            <Box paddingH={2} paddingV={2} width={['100%', null, '50%', '33%', '33%']}>
              <CuratedBoxOpenMenuTile handleOnClickOpenMenu={handleOnClickOpenMenu} />
            </Box>
          </Box>
        ) : (
          <CuratedBoxLoader />
        )}
      </Box>
    </Box>
  )
}
